import React from "react"

function IconChartLine({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="chart-line"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-chart-line"
      {...props}
    >
      <path
        d="M2.956 3.164c.326 0 .595.237.646.548l.009.106v15.71h17.711c.326 0 .596.237.646.548l.009.106a.655.655 0 0 1-.548.646l-.107.008H2.956a.655.655 0 0 1-.646-.548l-.008-.106V3.818c0-.361.293-.654.654-.654zM20.4 5.89a1.636 1.636 0 1 1-.39 3.226l-4.509 5.454a.655.655 0 0 1-.954.06l-.075-.086-2.581-3.465-4.212 5.091a1.636 1.636 0 1 1-1.01-.836l4.746-5.73a.655.655 0 0 1 .954-.058l.075.084 2.579 3.463 3.946-4.773A1.636 1.636 0 0 1 20.4 5.89z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconChartLine
